/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContractorListItemVm,
    ContractorListItemVmFromJSON,
    ContractorListItemVmFromJSONTyped,
    ContractorListItemVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContractorListItemVmPaginatedSearchResponse
 */
export interface ContractorListItemVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<ContractorListItemVm>}
     * @memberof ContractorListItemVmPaginatedSearchResponse
     */
    items?: Array<ContractorListItemVm> | null;
    /**
     * 
     * @type {number}
     * @memberof ContractorListItemVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorListItemVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorListItemVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorListItemVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorListItemVmPaginatedSearchResponse
     */
    size?: number;
}

export function ContractorListItemVmPaginatedSearchResponseFromJSON(json: any): ContractorListItemVmPaginatedSearchResponse {
    return ContractorListItemVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function ContractorListItemVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractorListItemVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(ContractorListItemVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function ContractorListItemVmPaginatedSearchResponseToJSON(value?: ContractorListItemVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(ContractorListItemVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


